import { fetch } from 'utils/api';

export const api_fetchTopicThresholdOptions = () =>
  fetch({
    url: '/topic_threshold_options',
    method: 'GET',
    dataType: 'Topic Thresholds',
    params: {}
  });
